import axios from "./axios";

export const fetch_linktrees = async (filter, limit, skip, orderBy) => {
  try {
    var url = `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/linktrees`;

    if (filter || limit || skip) url += `?`;
    if (filter) {
      for (const key in filter) {
        url += `&filter=AND(${key}:${filter[key]})`;
      }
    }

    if (skip) url += `&skip=${skip}`;
    if (limit) url += `&limit=${limit}`;
    if (orderBy) url += `&orderBy=${orderBy}`;

    const config = {
      method: "get",
      url: url,
      headers: { "Content-Type": "application/json" },
    };

    const result = await axios(config);
    return result.data;
  } catch (error) {
    return { success: false, message: error };
  }
};

export const fetch_linktree = async (id) => {
  try {
    const config = {
      method: "get",
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/linktrees/${id}`,
      headers: { "Content-Type": "application/json" },
    };

    const result = await axios(config);
    return { success: true, data: result.data?.data };
  } catch (error) {
    return { success: false, message: error };
  }
};

export const insert_linktree = async (payload) => {
  try {
    const config = {
      method: "post",
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/linktrees`,
      headers: { "Content-Type": "application/json" },
      data: payload,
    };

    const result = await axios(config);
    return result.data;
  } catch (error) {
    return { success: false, message: error };
  }
};

export const update_linktree = async (id, linktree) => {
  try {
    const data = JSON.stringify(linktree);

    const config = {
      method: "patch",
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/linktrees/${id}`,
      headers: { "Content-Type": "application/json" },
      data: data,
    };

    const result = await axios(config);
    return result.data;
  } catch (error) {
    return { success: false, message: error };
  }
};

export const delete_linktree = async (id) => {
  try {
    const config = {
      method: "delete",
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/linktrees/${id}`,
      headers: { "Content-Type": "application/json" },
    };

    const result = await axios(config);
    return result.data;
  } catch (error) {
    return { success: false, message: error };
  }
};

export const insert_linktree_link = async (linktreeId, link) => {
  try {
    const data = JSON.stringify(link);

    const config = {
      method: "post",
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/linktrees/${linktreeId}/links`,
      headers: { "Content-Type": "application/json" },
      data: data,
    };

    const result = await axios(config);
    return result.data;
  } catch (error) {
    return { success: false, message: error };
  }
};

export const update_linktree_link = async (linktreeId, linkId, link) => {
  try {
    const data = JSON.stringify(link);

    const config = {
      method: "patch",
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/linktrees/${linktreeId}/links/${linkId}`,
      headers: { "Content-Type": "application/json" },
      data: data,
    };

    const result = await axios(config);
    return result.data;
  } catch (error) {
    return { success: false, message: error };
  }
};

export const delete_linktree_link = async (linktreeId, linkId) => {
  try {
    const config = {
      method: "delete",
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/linktrees/${linktreeId}/links/${linkId}`,
      headers: { "Content-Type": "application/json" },
    };

    const result = await axios(config);
    return result.data;
  } catch (error) {
    return { success: false, message: error };
  }
};

export const sort_linktree_links = async (linktreeId, order) => {
  try {
    const config = {
      method: "patch",
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/linktrees/${linktreeId}/links/sort`,
      headers: { "Content-Type": "application/json" },
      data: {
        order,
      },
    };

    const result = await axios(config);
    return result.data;
  } catch (error) {
    return { success: false, message: error };
  }
};

export const upload_linktree_link_file = async (linktreeId, linkId, file) => {
  try {
    let formData = new FormData();
    formData.append("file", file);

    var config = {
      method: "post",
      url: `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/workplace/linktrees/${linktreeId}/links/${linkId}/upload`,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    };
    var result = await axios(config);
    return result.data;
  } catch (error) {
    return { success: false, message: error };
  }
};
